<template>
    <div class="block-redirect">
        <div
            class="block-redirect-item delete-wrapper"
            v-for="(block, index) in blocks"
        >
            <v-autocomplete
                    :items="blockList"
                    item-text="name"
                    multiple
                    item-value="id"
                    v-model="block.blocks"
                    :error="!block.blocks.length"
                    :error-messages="!block.blocks.length? 'Please select at least one block':'' "
                    outline
                    solo
                    chips
            >
                <template v-slot:selection="data">
                    <v-chip
                            :selected="data.selected"
                            close
                            color="#333"
                            @input="block.blocks.splice(block.blocks.indexOf(data.item.id), 1)"
                    >
                        <strong>{{ data.item.name }}</strong>&nbsp;
                    </v-chip>
                </template>
            </v-autocomplete>
            <v-btn
                    @click="deleteRandomBlock(index)"
                    fab small color=""
                    class="delete-button"
                    v-if="index > 0"
            ><v-icon small color="#666">delete_outline</v-icon></v-btn>
        </div>
        <v-btn
                large round flat block
                class="primary--text"
                @click="addRandomBlock"
                v-if="random === true"
        >
            <v-icon>add_circle_outline</v-icon>
            Add Random Block
        </v-btn>
    </div>
</template>

<script>
    export default {
        name: "block-redirect",
        props: {
            blocks: {
                type: Array,
                default: ()=> {
                    return []
                }
            },
            blockList: {
                type: Array,
                default: ()=> {
                    return []
                }
            },
            random: {
                type: Boolean,
                default: ()=>{
                    return false
                }
            }
        },
        data () {
            return {
            }
        },
        mounted() {
        },
        methods: {
            addRandomBlock() {
                this.blocks.push({
                    blocks: []
                })
            },
            deleteRandomBlock(index) {
                this.blocks.splice(index,1)
            }
        },
        watch: {
            random(state){
                if (state === false) {
                    this.blocks.splice(1)
                }
            }
        }
    }
</script>

<style scoped>

</style>